/** Shared currency formatter — Indian digit grouping + ₹ symbol for INR, plain currency-code
 * grouping for everything else. One source of truth so cards/lists/dashboard/detail pages
 * never diverge (was previously duplicated ad-hoc per page, some hardcoding "$"). */
function indianGroupInt(intStr) {
  if (intStr.length <= 3) return intStr;
  const last3 = intStr.slice(-3);
  const other = intStr.slice(0, -3).replace(/\B(?=(\d{2})+(?!\d))/g, ",");
  return `${other},${last3}`;
}

export function formatMoney(value, currency) {
  if (value === null || value === undefined || value === "") return "—";
  const n = Number(value);
  if (Number.isNaN(n)) return "—";
  const ccy = (currency || "INR").toUpperCase();
  const neg = n < 0;
  const abs = Math.abs(n);
  const [intPart, decPart] = abs.toFixed(2).split(".");
  const showDecimals = decPart !== "00";
  if (ccy === "INR") {
    const grouped = indianGroupInt(intPart);
    return `${neg ? "-" : ""}₹${grouped}${showDecimals ? `.${decPart}` : ""}`;
  }
  const western = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return `${neg ? "-" : ""}${ccy} ${western}${showDecimals ? `.${decPart}` : ""}`;
}
